import { createAction } from "@reduxjs/toolkit";
import { Pageable } from "../../services/pageable";
import {
  Fetchable,
  FetchableError,
  FetchableSuccess,
} from "../common/fetchable/helpers";
import { UsersDTO } from "./models/dto";

export namespace UserActions {
  export enum ActionTypes {
    getUserDetails = "Users: Get User Details",
    setUserDetails = "Users: Set User Details",
    resetUserDetails = "Users: Reset User Details",
    postUserDetails = "Users: Post User Details",

    getUsers = "Users: Get Users",
    setUsers = "Users: Set Users",
    setPagination = "Users: Set Pagination",
    resetUsers = "Users: Reset Users",
    getSingleUser = "Users: Get Single User",
    setSingleUser = "Users: Set Single User",
  }

  // Users Actions Types
  export const setUserDetails = createAction<
    FetchableSuccess<UsersDTO.Responses.GetSingle.T> | FetchableError
  >(ActionTypes.setUserDetails);

  export const getUserDetails = createAction(ActionTypes.getUserDetails);
  export const resetUserDetails = createAction(ActionTypes.resetUserDetails);

  export const postUserDetails = createAction<
    UsersDTO.Requests.UserDetails.T,
    ActionTypes.postUserDetails
  >(ActionTypes.postUserDetails);

  export const getUsers = createAction(ActionTypes.getUsers);
  export const resetUsers = createAction(ActionTypes.resetUsers);

  export const setUsers = createAction<
    FetchableSuccess<UsersDTO.Responses.GetAll.T> | FetchableError,
    ActionTypes.setUsers
  >(ActionTypes.setUsers);

  export const getSingleUser = createAction<
    {
      userId: UsersDTO.Responses.GetSingle.T["userReferenceId"];
      refetch?: boolean;
    },
    ActionTypes.getSingleUser
  >(ActionTypes.getSingleUser);

  export const setSingleUser = createAction<
    Fetchable<UsersDTO.Responses.GetSingle.T>,
    ActionTypes.setSingleUser
  >(ActionTypes.setSingleUser);

  export const setPagination = createAction<
    Pageable.T<keyof UsersDTO.Responses.GetSingle.T>,
    ActionTypes.setPagination
  >(ActionTypes.setPagination);

  export type SetUserDetails = ReturnType<typeof setUserDetails>;
  export type GetUserDetails = ReturnType<typeof getUserDetails>;
  export type PostUserDetails = ReturnType<typeof postUserDetails>;
  export type ResetUserDetails = ReturnType<typeof resetUserDetails>;
  export type GetUsers = ReturnType<typeof getUsers>;
  export type ResetUsers = ReturnType<typeof resetUsers>;
  export type SetUsers = ReturnType<typeof setUsers>;
  export type GetSingleUser = ReturnType<typeof getSingleUser>;
  export type SetSingleUser = ReturnType<typeof setSingleUser>;
  export type SetPagination = ReturnType<typeof setPagination>;

  export type Actions =
    | GetUserDetails
    | SetUserDetails
    | PostUserDetails
    | ResetUserDetails
    | GetUsers
    | ResetUsers
    | SetUsers
    | GetSingleUser
    | SetSingleUser
    | SetPagination;
}
